import {
  EXAM_COURSE_LANGUAGE_TEXT,
  EXAM_COURSE_TYPE_TEXT,
} from '@exam-center/exam-course-management';
import type { ExamCourseLanguage, ExamCourseType } from '@exam-center/graphql';
import { CopyToClipboard, EllipsisText, type GridColDef } from '@shared/components';
import { formatDateTime } from '@shared/utils';

export interface ExamCenterCourseListItem {
  id: string;
  examId: number;
  code: string;
  name: string;
  type: ExamCourseType;
  language: ExamCourseLanguage;
  createdAt: Date;
}

export const columns: GridColDef<ExamCenterCourseListItem>[] = [
  {
    field: 'examId',
    headerName: 'ExamID',
    headerAlign: 'center',
    align: 'center',
    sortable: true,
    width: 100,
  },
  {
    field: 'code',
    headerName: 'Exam Code',
    sortable: false,
    width: 210,
    renderCell: ({ row }) => {
      return (
        <CopyToClipboard
          sx={(theme) => ({
            borderRadius: theme.shape.rounded(1),
            '&:hover': {
              backgroundColor: theme.palette.grey[200],
            },
          })}
          text={row.code}
        >
          {row.code}
        </CopyToClipboard>
      );
    },
  },
  {
    field: 'name',
    headerName: 'Name',
    sortable: false,
    flex: 1,
    renderCell: ({ row }) => {
      return <EllipsisText variant='body1Semibold'>{row.name}</EllipsisText>;
    },
  },
  {
    field: 'type',
    headerName: 'Type',
    sortable: false,
    width: 80,
    renderCell: ({ row }) => {
      const { type } = row;
      return <EllipsisText>{EXAM_COURSE_TYPE_TEXT[type]}</EllipsisText>;
    },
  },
  {
    field: 'language',
    headerName: 'Language',
    sortable: false,
    width: 94,
    renderCell: ({ row }) => {
      const { language } = row;
      return <EllipsisText>{EXAM_COURSE_LANGUAGE_TEXT[language]}</EllipsisText>;
    },
  },
  {
    field: 'createdAt',
    headerName: 'Date Added',
    sortable: false,
    width: 160,
    valueFormatter: (params) => {
      return `${params.value ? formatDateTime(params.value) : '-'}`;
    },
  },
];
